import {
  CurrencyDollarIcon,
  DeviceMobileIcon,
  GlobeAltIcon,
  PhoneIcon,
} from "@heroicons/react/solid";
import React from "react";
import BookWithUsCards from "./BookWithUsCards";
import "aos/dist/aos.css";

const BookWithUs = () => {
  return (
    // <div className="bg-white w-full h-[36rem] sm:h-[390px] sm:mt-0">
    <div className="bg-white w-full sm:mt-0">
      <div className="py-2 m-auto text-2xl font-body font-semibold text-center text-black capitalize md:text-3xl lg:text-4xl pt-9 pb-7 sm:pt-10 md:pt-12">
        Why book <span className="font-body text-secondary"> with us? </span>
      </div>

      {/* -------------------------------------- Book with us cards - MOBILE VIEW -------------------------------- */}
      <div className="space-y-2 md:hidden lg:hidden text-secondary">
        <BookWithUsCards
          Icon={GlobeAltIcon}
          heading="Global Availability"
          paragraph="One single platform for booking safe and reliable chauffeur transfers worldwide."
        />
        <BookWithUsCards
          Icon={DeviceMobileIcon}
          heading="Reservation by Phone/Email"
          paragraph="Unable to book online? No worries! Call/email us."
        />
        <BookWithUsCards
          Icon={CurrencyDollarIcon}
          heading="No Hidden Cost"
          paragraph="Prices are inclusive of tolls, taxes and gratuities."
        />
        <BookWithUsCards
          Icon={PhoneIcon}
          heading="24X7 Services"
          paragraph="24x7 Real Time Quote, Booking and Customer Care."
        />
      </div>

      {/* ----------------------------- WEB VIEW both medium screeen and large screen ------------------------------------- */}
      {/* Book with us cards - mobile view */}
      <div className="hidden text-secondary lg:mt-10 justify-between md:mx-5 xl:mx-36 2xl:mx-56 md:grid md:grid-cols-2 lg:grid-cols-4">
        <BookWithUsCards
          Icon={GlobeAltIcon}
          heading="Global Availability"
          paragraph="One single platform for booking safe and reliable chauffeur transfers worldwide."
        />
        <BookWithUsCards
          Icon={DeviceMobileIcon}
          heading="Reservation by Phone/Email"
          paragraph="Unable to book online? No worries! Call/email us."
        />

        <BookWithUsCards
          Icon={CurrencyDollarIcon}
          heading="No Hidden Cost"
          paragraph="Prices are inclusive of tolls, taxes and gratuities."
        />
        <BookWithUsCards
          Icon={PhoneIcon}
          heading="24X7 Services"
          paragraph="24x7 Real Time Quote, Booking and Customer Care."
        />
      </div>
    </div>
  );
};

export default BookWithUs;
